import React, { useEffect, useRef } from "react";
import { useColorPalette } from "./hooks/useColorPalette";
import { ExlyInput } from "common/form";
import { useIsDesktop } from "features/Common/modules/Viewport/utils/Viewport.utils";
import {
  color_picker_debounce_ms,
  default_hex_color,
} from "./ColorPalette.constants";

const color_fields = [
  { key: "template-primary-color", label: "Primary colour" },
  { key: "template-secondary-color", label: "Secondary colour" },
  { key: "template-page-background", label: "Page background colour" },
  { key: "template-primary-button-text-color", label: "Button text colour" },
];

export const ColorPalette = () => {
  const { colors, updateColor } = useColorPalette();
  const isDesktop = useIsDesktop();
  const inputRefs = useRef({});
  const debounceTimersRef = useRef({});
  const updateColorRef = useRef(updateColor);

  useEffect(() => {
    updateColorRef.current = updateColor;
  });

  useEffect(() => {
    return () => {
      Object.values(debounceTimersRef.current).forEach((timer) =>
        clearTimeout(timer)
      );
    };
  }, []);

  const scheduleUpdateColor = (key, value) => {
    if (debounceTimersRef.current[key]) {
      clearTimeout(debounceTimersRef.current[key]);
    }
    debounceTimersRef.current[key] = setTimeout(() => {
      updateColorRef.current(key, value);
    }, color_picker_debounce_ms);
  };

  const handleSwatchClick = (key) => {
    if (inputRefs.current[key]) {
      inputRefs.current[key].click();
    }
  };

  const handleTextBlur = (key, event) => {
    if (debounceTimersRef.current[key]) {
      clearTimeout(debounceTimersRef.current[key]);
    }
    let val = event.target.value.trim();
    if (val && !val.startsWith("#")) val = `#${val}`;
    updateColor(key, val.toUpperCase());
  };

  return (
    <div className={!isDesktop ? "tw-w-full" : "tw-w-[43%]"}>
      <div className="tw-flex tw-flex-col tw-gap-4">
        {color_fields.map(({ key, label }) => {
          const currentColor = colors[key] || default_hex_color;
          return (
            <div key={key} className="tw-flex tw-flex-col tw-gap-1.5">
              <label className="tw-text-sm tw-font-medium tw-text-[#272522]">
                {label}
              </label>
              <div className="tw-flex tw-items-center tw-gap-3">
                <div
                  onClick={() => handleSwatchClick(key)}
                  className="tw-w-10 tw-h-10 tw-min-w-[40px] tw-min-h-[40px] tw-rounded-md tw-border tw-border-solid tw-border-[#D1D5DB] tw-cursor-pointer tw-shadow-sm tw-relative tw-flex-shrink-0"
                  style={{ backgroundColor: currentColor }}
                  title="Click to pick color"
                >
                  <input
                    ref={(el) => (inputRefs.current[key] = el)}
                    type="color"
                    value={currentColor}
                    onChange={(e) =>
                      scheduleUpdateColor(key, e.target.value.toUpperCase())
                    }
                    className="tw-absolute tw-opacity-0 tw-w-0 tw-h-0 tw-pointer-events-none"
                  />
                </div>
                <div className="tw-flex-1">
                  <ExlyInput
                    value={currentColor}
                    onChange={(val) => scheduleUpdateColor(key, val)}
                    onBlur={(e) => handleTextBlur(key, e)}
                    placeholder={default_hex_color}
                    fullWidth
                    inputClassName="tw-bg-white"
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
